<template> 
  <base-layout>
    <ul class="nav navbar-nav navbar-left" slot="toolbar_buttons">
      <li>
        <date-range-picker :datesRange="datesRange" @dates-range-updated="updatedDates"></date-range-picker>
      </li>
    </ul>
    
    <div class="col-xs-12 main" slot="main">
      <div class="row">
        <div class="col-xs-12 spinner-container" v-if="isLoading">
          <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw" aria-hidden="true"></i>
        </div>
      </div>
      <div class="row" v-if="!isLoading && error">
        <div class="col-xs-12">
          <div class="well">{{ message }}</div>
        </div>
      </div>
      <div class="row ls-charts" v-if="!isLoading && !error">
        <h1>Model Analytics</h1>

        <div v-if="!models.length">
          <div class="col-xs-12">
            <div class="well">There is no data available for this account</div>
          </div>
        </div>
        
        <div v-for="model in models" class="col-xs-12">
          <h3><span><i v-if="model.active" class="fa fa-check" ></i> </span>{{ model.name }} <small>{{ model.created|formatDate }}</small></h3>
          <div class="col-xs-12" v-if="model.empty">
            <div class="well">There is no data available for this period of time</div>
          </div>
          <div class="col-xs-12" v-if="!model.empty">
          <div class="col-xs-3">
            <div class="box">
              <div class="panel stats">
                <div class="panel-header">
                  <h3>Scored</h3>
                </div>
                <div class="panel-body">
                  <div class="metrics-banner-text text-center">{{ model.stats.scored }}</div>
                </div>
              </div>
            </div>
          </div>
          
          
          <div class="col-xs-3">
            <div class="box">
              <div class="panel stats">
                <div class="panel-header">
                  <h3>Conversions</h3>
                </div>
                <div class="panel-body">
                  <div class="metrics-banner-text text-center">{{ model.stats.converters }}</div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="col-xs-3">
            <div class="box">
              <div class="panel stats">
                <div class="panel-header">
                  <h3>Conv. Rate</h3>
                </div>
                <div class="panel-body">
                  <div class="metrics-banner-text text-center">{{ model.stats.conv_rate | percentage(2) }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-3">
            <div class="box">
              <div class="panel stats">
                <div class="panel-header">
                  <h3>Delta</h3>
                </div>
                <div class="panel-body">
                  <div class="metrics-banner-text text-center">
                    {{ model.stats.delta | decimal }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <template v-if="model.grading_engine">
              <div class="col-xs-12 col-md-6">
                  <div class="box">
                      <div class="panel stats">
                          <div class="panel-header">
                              <h3>Baseline Stats</h3>
                          </div>
                          <div class="panel-body">
                              <table class="table">
                                  <thead>
                                      <tr>
                                          <th v-for="h in model.grading_engine.stats.baseline.header">{{ h }}</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr v-for="r in model.grading_engine.stats.baseline.rows" :class="{grade: r[0]}">
                                          <th>{{ r[0] }}</th>
                                          <td>{{ r[1] }}</td>
                                          <td>{{ r[2] | decimal }}</td>
                                          <td>{{ r[3] | percentage }}</td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>
              </div>

              <div class="col-xs-12 col-md-6">
                  <div class="box">
                      <div class="panel stats">
                          <div class="panel-header">
                              <h3>Current Stats</h3>
                          </div>
                          <div class="panel-body">
                              <table class="table">
                                  <thead>
                                      <tr>
                                          <th v-for="h in model.grading_engine.stats.current.header">{{ h }}</th>
                                          <th>Conv. Rate</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr v-for="r in model.grading_engine.stats.current.rows" :class="{grade: r[0]}">
                                          <th>{{ r[0] }}</th>
                                          <td>{{ r[1] }}</td>
                                          <td>{{ r[2] | decimal }}</td>
                                          <td>{{ r[3] | percentage }}</td>
                                          <td>{{ r[4] }}</td>
                                          <td>{{ r[5] }}</td>
                                          <td>{{ r[5]/r[4] | percentage }}</td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>
              </div>
          </template>

          <div class="col-xs-12">
            <div class="box">
              <div class="panel stats">
                <div class="panel-header">
                  <h3>Analysis by Decile</h3>
                </div>
                <div class="panel-body">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Decile</th>
                        <th v-for="h in model.deciles.header">{{ h }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="r in model.deciles.rows">
                        <th>{{ r.key }}</th>
                        <td>{{ r.data[0] }}</td>
                        <td>{{ r.data[1] }}</td>
                        <td>{{ r.data[2] }}</td>
                        <td>{{ r.data[3] | percentage(2) }}</td>
                        <td>{{ r.data[4] | percentage(2) }}</td>
                        <td>{{ r.data[5] | percentage(2) }}</td>
                        <td>{{ r.data[6] | percentage(2) }}</td>
                      </tr>
                    </tbody>
                  </table>
                  
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-lg-6">
            <div class="box">
              <div class="panel stats">
                <div class="panel-header">
                  <h3>Distribution by Decile</h3>
                </div>
                <div class="panel-body">
                  <div class="col-xs-12 chart-wrapper">
                    <ls-chart target-css-classes="chart" 
                              :target-id="'dist_chart_' + model.id"
                              v-bind:bc-data="model.distribution_by_decile.series" 
                              v-bind:bc-layout="model.distribution_by_decile.layout">
                    </ls-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-lg-6">
            <div class="box">
              <div class="panel stats">
                <div class="panel-header">
                  <h3>Conv. Rate by Decile</h3>
                </div>
                <div class="panel-body">
                  <div class="col-xs-12 chart-wrapper">
                    <ls-chart target-css-classes="chart" 
                              :target-id="'conv_chart_' + model.id"
                              v-bind:bc-data="model.conv_rate_by_decile.series" 
                              v-bind:bc-layout="model.conv_rate_by_decile.layout">
                    </ls-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-lg-6">
            <div class="box">
              <div class="panel stats">
                <div class="panel-header">
                  <h3>Capture rate</h3>
                </div>
                <div class="panel-body">
                  <div class="col-xs-12 chart-wrapper">
                    <ls-chart target-css-classes="chart" 
                              :target-id="'capture_' + model.id"
                              v-bind:bc-data="model.capture_rate.series" 
                              v-bind:bc-layout="model.capture_rate.layout">
                    </ls-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-lg-6">
            <div class="box">
              <div class="panel stats">
                <div class="panel-header">
                  <h3>Score Delta</h3>
                </div>
                <div class="panel-body">
                  <div class="col-xs-12 chart-wrapper">
                    <ls-chart target-css-classes="chart" 
                              :target-id="'delta_' + model.id"
                              v-bind:bc-data="model.score_delta.series" 
                              v-bind:bc-layout="model.score_delta.layout">
                    </ls-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </base-layout>
</template>

<script>
/**
 * https://github.com/jbaysolutions/vue-grid-layout
 */
import Vue from 'vue';
import {BaseLayout} from 'components/layouts/';
import LsChart from 'components/elements/PlotlyJS/LSBasicChart';
import DateRangePicker from 'components/elements/DateRangePicker';
// Load the full build. 
var _ = require('lodash');


export default {
  components: {
    BaseLayout,
    LsChart,
    DateRangePicker
  },

  data () {
    return {
      isLoading: true,
      error: false,
      message: "",
      models: [],
      query: {},
      datesRange: {
        from: moment().subtract(29, "days").format("YYYY-MM-DD"),
        to: null,
        date_field: null
      }
    };
  },

  computed: {
    dateRangeTarget () {
      return `table-daterange-${Date.now()}`;
    },
    dateRangeTargetId () {
      return `#${this.dateRangeTarget}`;
    },
    ToogleSidebarEvent () {
      return new CustomEvent('ToogleSidebar');
    }
  },
  created () {
      this.queryBackend();
      BUS.$on('refreshDashboard', this.queryBackend);
  },
  methods: {
    updatedDates: _.debounce(function (datesRange) {
      Vue.set(this, 'datesRange', datesRange);
      this.queryBackend();
    }),
    queryBackend() {
      var self = this;
      this.query.from = this.datesRange.from;
      this.query.to = this.datesRange.to;
      this.query.date_field = this.datesRange.date_field;
      API.modelanalytics.models(self.query).then(function (data) {
        if (data.body.error) {
          self.error = data.body.error;
          self.message = data.body.message;
        }
        else {
          self.error = data.body.error;
          self.models = data.body.models;
        }
        self.isLoading = false;
      });
    },
    draw () {
      var self = this;
    }
  }
}
</script>

<style scoped>
  h3 {
  margin: 10px;
  }
.dashboard-header {
  color: #ddd;
  border-bottom: 1px solid #ddd;
  margin-bottom: 4px;
  padding: 0px;
}
.dashboard-header .btn-group {
  display: inline-block;
  margin-top: 3px;
}
.dashboard-header .col-xs-10,
.dashboard-header .col-xs-2 {
  padding-left: 3px;
  padding-right: 3px;
}
.dashboard-header h3 {
  color: #ddd;
  font-size: 14pt;
}
.dashboard-header .btn-default {
  color: #ddd!important;
  border: 0px;
  border-radius: 0px;
  background: transparent;
}
.dashboard-header .btn-default:hover,
.dashboard-header .btn-default:focus,
.dashboard-header .btn-default:active {
  border: 0px;
  background: #aeaeae;
  shadow-box: 0;
  color: #555!important;
}

.panel.stats .panel-body {
  overflow: hidden;
}

.panel.field_analysis .panel-body {
  height: 400px;
  overflow: hidden;
}

.empty-msg {
  margin: 30px auto;
}
.box {
  padding: 10px;
}

.panel.field_analysis .chart-wrapper {
  padding: 0px!important;
  height: 310px!important;
}

.js-plotly-plot {
  overflow: hidden;
}

.plot-container,
.svg-container {
  width: 100%!important;
  height: 100%!important;
  overflow: hidden;
}

.metrics-banner-text {
  font-size: 1.8em;
  font-weight: 600;
  color: #ff7a7c;
}

.main {
  overflow: auto;
}
.chart-wrapper {
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// ModelAnalytics.vue?5ae350b3